import { ActionMenu } from 'ui/actionMenu';
import { ButtonOption, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Close16 } from 'ui/icons';
import { CustomInsightRemovalMenuButton } from './InsightPanel.styled';

type CustomInsightRemovalMenuProps = {
  options: ButtonOption[];
};

export const CustomInsightRemovalMenu = ({ options }: CustomInsightRemovalMenuProps) => {
  return (
    <ActionMenu options={options} align={MENU_ALIGNMENTS.RIGHT}>
      <CustomInsightRemovalMenuButton size={BUTTON_SIZES.SMALL} variant={BUTTON_VARIANTS.SECONDARY}>
        <Close16 />
      </CustomInsightRemovalMenuButton>
    </ActionMenu>
  );
};
